export enum DocumentType {
    IdentityCard = 'identity_card',
    DrivingLicense = 'driving_license',
    }